import React from 'react'
import styled from "@emotion/styled";
import { H5 } from "@styles/Global.styles";

export const PlateSizeGuideContainer = styled.div`
    padding: 20px;
    width: 300px;
`

export const PlateSizeGuideHeading = styled(H5)`
    padding-bottom: 10px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EEEEEE;

`

export const PlateSizeGuidePlate = styled(({width, height, ...others})=><div {...others} />)`
    width: ${props => props.width * 0.1923}%;
    height: ${props => props.height * 0.6452}%;
    border: 3px solid #707070;
    border-radius: 4px;
`

export const PlateSizeGuidePlateContainer = styled.div`
    width: 120px;
    height: 40px;
`
